module.exports = {"370812001":"鼓楼街道","370812003":"龙桥街道","370812006":"酒仙桥街道","370812101":"大安镇","370812102":"新驿镇","370812103":"颜店镇","370812105":"新兖镇","370812107":"漕河镇","370812110":"兴隆庄镇","370812111":"小孟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370812.json
// module id = 1315
// module chunks = 0